/* ──────────────────────────────────────────
   DBD Fit Preselect
   Reads the model saved by the collection page (localStorage 'dbd:fit:model',
   written by dbd-collection.js) and pre-selects the matching Model option on
   the PDP. Matching is by slug: 'MacBook Pro 14" (M1–M4)' → macbook-pro-14-m1-m4,
   which is exactly the fit:* tag id format. No-ops when nothing is saved,
   nothing matches, or the URL carries an explicit ?variant= deep link.
   ────────────────────────────────────────── */
(function () {
  'use strict';
  var fit = null;
  try { fit = localStorage.getItem('dbd:fit:model'); } catch (e) {}
  if (!fit) return;
  if (new URLSearchParams(location.search).has('variant')) return;

  function slug(s) {
    return String(s).toLowerCase()
      .replace(/[\u201C\u201D"\u2033'\u2019()]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Return index of the value matching the saved fit id: exact slug match,
  // else a single unambiguous prefix match (option "MacBook Pro 14"" vs
  // fit id macbook-pro-14-m1-m4). Prefix must be ≥8 chars to avoid noise.
  function match(values) {
    var slugs = values.map(slug);
    var i = slugs.indexOf(fit);
    if (i < 0) {
      var hits = [];
      slugs.forEach(function (s, j) { if (s.length >= 8 && fit.indexOf(s) === 0) hits.push(j); });
      if (hits.length === 1) i = hits[0];
    }
    return i;
  }

  function run() {
    // Radio-based pickers (generic option pickers + dock model picker)
    var groups = {};
    document.querySelectorAll('input[type="radio"][data-option-input], input[type="radio"][name="model-picker"]').forEach(function (r) {
      (groups[r.name] = groups[r.name] || []).push(r);
    });
    Object.keys(groups).forEach(function (k) {
      var radios = groups[k];
      var i = match(radios.map(function (r) { return r.value; }));
      if (i < 0 || radios[i].checked || radios[i].disabled) return;
      radios[i].checked = true;
      radios[i].dispatchEvent(new Event('change', { bubbles: true }));
    });
    // Select-based pickers
    document.querySelectorAll('select[data-option-input]').forEach(function (sel) {
      var opts = [].slice.call(sel.options);
      var i = match(opts.map(function (o) { return o.value; }));
      if (i < 0 || sel.selectedIndex === i || opts[i].disabled) return;
      sel.selectedIndex = i;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
